import { provideHooks } from "../../../../../helpers/routeHooks";
import { withTranslation } from "../../../../../components/translation";
import SearchPage from "./SearchPage";
import {
  fetchSearch,
  getIsNewSearch,
  sendPlacementOnLoadBeacon,
} from "../../../../../state/modules/search";
import {
  setPageLoading,
  setIsNewPage,
} from "../../../../../state/modules/page/actions";
import { analyticsPageLoad } from "../../../../../state/modules/analytics/actions";
import {
  clearCategoryDetails,
  clearCuratedCategoryTreatments,
} from "../../../../../state/modules/category/actions/";

const isValidSearch = (location) => {
  const searchTerm =
    (new URLSearchParams(location?.search).get("q") || "").trim().length > 0;

  return searchTerm;
};

export const hooks = {
  fetch: ({ dispatch, location, store, uuid, xSiteOrigin, isNewPage }) => {
    const state = store.getState();
    if (isValidSearch(location)) {
      if (!getIsNewSearch(state)) {
        return;
      }

      return dispatch(fetchSearch(uuid, xSiteOrigin, isNewPage, location))
        .then(() => {
          dispatch(sendPlacementOnLoadBeacon());
          if (isNewPage) {
            dispatch(clearCategoryDetails());
            dispatch(clearCuratedCategoryTreatments());
            dispatch(analyticsPageLoad());
            dispatch(setIsNewPage(false));
          }
        })
        .catch((error) => {
          if (typeof window === "undefined") {
            throw error;
          }
        })
        .finally(() => {
          dispatch(setPageLoading(false));
        });
    }

    dispatch(setPageLoading(false));
  },
};

export { SearchPage };

export default provideHooks(hooks)(withTranslation(SearchPage));
